import { Box, Grid, Rating, Stack, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../constants/Colors";
import { t } from "i18next";

function StatusCard({ item, showRatings, index }) {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Stack
        p={2}
        borderRadius={"10px"}
        bgcolor={appcolors.white}
        boxShadow={"2px 2px 10px 0px #ECF0F2"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        height={showRatings ? "70px" : "auto"}
      >
        <Box>
          <Typography
            variant={"body1"}
            fontSize={"1.125rem"}
            fontWeight={600}
            lineHeight={"normal"}
          >
            {t(item?.primary)}
          </Typography>
          {showRatings && index === 0 ? (
            <Rating
              name="size-small"
              defaultValue={2}
              value={item?.rating}
              size="small"
              precision={0.5}
            />
          ) : (
            <Typography
              fontSize={"0.86rem"}
              color={appcolors.crayolaGrey}
              lineHeight={"normal"}
            >
              {t(item?.secondary)}
            </Typography>
          )}
        </Box>
        <Typography variant={"h3"} fontSize={"1.125rem"} fontWeight={600}>
          {item?.value}
        </Typography>
      </Stack>
    </Grid>
  );
}

export default StatusCard;
